import React from "react";

/**
 * LogoMonogram — "DC" mark used in the topbar, login card and PWA install
 * banner. Pure SVG, scales by `size` prop. Two-tone gradient based on
 * Tokyo-Night accents (cyan → indigo) on a dark background.
 */
export default function LogoMonogram({ size = 28, className = "", testId }) {
  return (
    <svg
      role="img"
      aria-label="Distribución Canales"
      width={size}
      height={size}
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid={testId || "logo-monogram"}
    >
      <defs>
        <linearGradient id="dc-bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#1A1B26" />
          <stop offset="100%" stopColor="#24283B" />
        </linearGradient>
        <linearGradient id="dc-stroke" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#7DCFFF" />
          <stop offset="100%" stopColor="#BB9AF7" />
        </linearGradient>
      </defs>
      <rect
        x="1"
        y="1"
        width="46"
        height="46"
        rx="12"
        fill="url(#dc-bg)"
        stroke="url(#dc-stroke)"
        strokeWidth="1.5"
      />
      {/* D */}
      <path
        d="M11 13 H19 C24.5 13 28 16.7 28 23.5 C28 30.3 24.5 34 19 34 H11 Z M15.5 17.5 V29.5 H18.5 C21.7 29.5 23.5 27.4 23.5 23.5 C23.5 19.6 21.7 17.5 18.5 17.5 Z"
        fill="#FAFAFA"
      />
      {/* C */}
      <path
        d="M40 19.5 C39.2 17.8 37.5 16.5 35.4 16.5 C32 16.5 30 19.4 30 23.5 C30 27.6 32 30.5 35.4 30.5 C37.6 30.5 39.3 29.1 40 27.4 L36.4 26 C36.1 26.7 35.5 27.1 34.7 27.1 C33.4 27.1 32.7 26 32.7 23.5 C32.7 21 33.4 19.9 34.7 19.9 C35.5 19.9 36.1 20.3 36.4 21 Z"
        fill="#7DCFFF"
      />
    </svg>
  );
}
